import { Button, Form, Input, Modal, notification, Select } from "antd";
import { FormInstance } from "antd/es/form/Form";
import React from "react";
import { isGranted } from "../../lib/abpUtility";
import { SendMailDto, UserServiceProxy } from "../../services/serviceProxy";
import { AppTopNaviDivider } from "@abb/abb-common-ux-react";
import { NodeIndexOutlined } from "@ant-design/icons";

const { TextArea } = Input;
const { Option } = Select;

class ContactUs extends React.Component {
    formRef = React.createRef<FormInstance>();

    state = {
        visible: false,
        loading: false
    };

    contactUs = () => {
        this.setState({
            visible: true,
            loading: false
        });
    }

    formSubmit = async () => {
        const value = await this.formRef.current.validateFields();
        this.setState({
            loading: true
        });
        const userserver = new UserServiceProxy();
        const result = await userserver.sendMail({
            sendMailType: 3,
            subject: value.type,
            body: "联系人:" + value.name + "丨手机号:" + value.phone + "丨邮箱:" + value.email + "丨标题:" + value.subject + "丨描述:" + value.details,
            sendMailUserDtos: [{
                email: 'cn-motorsalesportal@abb.com'
            }]
        } as SendMailDto);
        if (result === "成功") {
            notification.success({ message: '问题反馈已提交，我们工程师会尽快与您取得联系' });
            this.setState({
                visible: false
            });
        } else {
            this.setState({
                loading: false
            });
        }
    }

    // 打开CCS系统
    handleOpenCcs() {
        window.open(process.env.REACT_APP_CCS_URL, "blank")
    }

    render() {
        const { visible, loading } = this.state;
        return (
            <>
                {
                    isGranted("Role.CP")
                        ? <>
                            <Button icon={<NodeIndexOutlined />} type="text" onClick={this.handleOpenCcs} title="工单系统,查看历史协助情况">工单</Button>
                            <AppTopNaviDivider />
                        </>
                        : <></>
                }
                {
                    visible ?
                        <Modal
                            visible={true}
                            title="请填写"
                            okText="提交"
                            cancelText="取消"
                            confirmLoading={loading}
                            onCancel={() => {
                                this.setState({
                                    visible: false
                                });
                            }}
                            onOk={() => {
                                this.formSubmit();
                            }}
                        >
                            <Form
                                ref={this.formRef}
                                layout="vertical"
                            >
                                <Form.Item
                                    name="name"
                                    label="联系人"
                                    rules={[{ required: true }]}
                                >
                                    <Input></Input>
                                </Form.Item>
                                <Form.Item
                                    name="phone"
                                    label="手机号"
                                    rules={[{ required: true }]}
                                >
                                    <Input></Input>
                                </Form.Item>
                                <Form.Item
                                    name="email"
                                    label="邮箱"
                                    rules={[{ required: true, type: 'email' }]}
                                >
                                    <Input></Input>
                                </Form.Item>
                                <Form.Item
                                    name="subject"
                                    label="标题"
                                    rules={[{ required: true }]}
                                >
                                    <Input></Input>
                                </Form.Item>
                                <Form.Item
                                    name="type"
                                    label="问题类型"
                                    rules={[{ required: true }]}
                                >
                                    <Select>
                                        <Option value={"OIS"}>OIS</Option>
                                        <Option value={"SmartConfigurator"}>SmartConfigurator</Option>
                                        <Option value={"其它"}>其它</Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    name="details"
                                    label="描述"
                                    rules={[{ required: true }]}
                                >
                                    <TextArea rows={4}></TextArea>
                                </Form.Item>
                            </Form>
                        </Modal>
                        : ''
                }
            </>
        );
    }
}

export default ContactUs;